/* Black November: countdowns, card add buttons, PDP offer mount and free gift lines.
   Shopify stays the price authority: a gift line survives only if Shopify prices it at $0. */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var RELOAD_KEY = 'irBnReloaded';

  function parts(end) {
    var left = Math.max(0, end - Math.floor(Date.now() / 1000));
    return { left: left, d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60, s: left % 60 };
  }

  function paint(el, p) {
    var kind = el.getAttribute('data-irbn-countdown');
    if (kind === 'tiles') {
      var day = el.querySelector('[data-irbn-unit="d"]');
      if (day) {
        day.hidden = p.d === 0;
        day.style.display = p.d === 0 ? 'none' : '';
        day.querySelector('[data-v]').textContent = pad(p.d);
      }
      el.querySelector('[data-irbn-h]').textContent = pad(p.h);
      el.querySelector('[data-irbn-m]').textContent = pad(p.m);
      el.querySelector('[data-irbn-s]').textContent = pad(p.s);
      if (p.d === 0 && p.left < 86400) {
        var label = el.parentNode && el.parentNode.querySelector('[data-irbn-label]');
        if (label) label.textContent = 'Ends tonight';
      }
    } else if (kind === 'pill') {
      el.querySelector('[data-irbn-text]').textContent = 'Ends in ' + (p.d ? p.d + 'd ' : '') + pad(p.h) + ':' + pad(p.m) + ':' + pad(p.s);
    } else {
      el.querySelector('[data-irbn-text]').textContent = (p.d ? p.d + 'd ' : '') + p.h + 'h ' + pad(p.m) + 'm left';
    }
  }

  function label(el, p) {
    var text = 'Sale ends in ' + (p.d ? p.d + ' days ' : '') + p.h + ' hours' + (p.d ? '' : ' ' + p.m + ' minutes');
    el.setAttribute('aria-label', text);
  }

  /* Hero shows the stock message until the sale's last days, then the countdown. */
  function startHeroTimer() {
    var actions = document.querySelector('[data-irbn-hero-actions]');
    if (!actions) return;
    var timer = actions.querySelector('.irbn-hero__timer');
    var countdown = actions.querySelector('[data-irbn-countdown]');
    if (!timer || !countdown) return;
    var days = Number(actions.getAttribute('data-days')) || 7;
    if (parts(Number(countdown.getAttribute('data-end'))).left <= days * 86400) {
      timer.hidden = false;
      actions.classList.add('irbn-hero__actions--timer');
    }
  }

  function startCountdowns() {
    var timers = Array.prototype.slice.call(document.querySelectorAll('[data-irbn-countdown]'));
    if (!timers.length) return;
    var lastMinute = -1;
    function tick() {
      var minute = Math.floor(Date.now() / 60000);
      var expired = false;
      timers.forEach(function (el) {
        var p = parts(Number(el.getAttribute('data-end')));
        paint(el, p);
        if (minute !== lastMinute) label(el, p);
        if (p.left === 0) expired = true;
      });
      lastMinute = minute;
      if (expired) {
        // Reload once to pick up the next phase, or to remove the sale after Dec 2.
        var key = RELOAD_KEY + timers[0].getAttribute('data-end');
        try {
          if (sessionStorage.getItem(key)) return;
          sessionStorage.setItem(key, '1');
        } catch (_e) { return; }
        window.location.reload();
        return;
      }
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  }

  function startCardAdds() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-irbn-add]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      var cart = window.InfrarediKallesCart;
      var id = button.getAttribute('data-irbn-add');
      var text = button.textContent;
      if (!cart) { window.location.href = button.getAttribute('data-href'); return; }
      button.disabled = true;
      cart.add({ root: button, item: { id: id, quantity: 1 }, productId: button.getAttribute('data-product') })
        .catch(function () { window.location.href = button.getAttribute('data-href'); })
        .finally(function () { button.disabled = false; button.textContent = text; });
    });
  }

  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function findAddButton() {
    var main = document.getElementById('MainContent');
    if (!main) return null;
    var marked = main.querySelectorAll('[data-ir-add-product-variant-to-cart], [data-ir-hat-add], [name="add"], [type="submit"]');
    var i;
    for (i = 0; i < marked.length; i++) if (visible(marked[i])) return marked[i];
    var all = main.querySelectorAll('button, [role="button"], a');
    for (i = 0; i < all.length; i++) {
      if (visible(all[i]) && /^(add to cart|notify me|out of stock|pre-?order)/i.test((all[i].textContent || '').trim())) return all[i];
    }
    return null;
  }

  function findGallery(button) {
    var main = document.getElementById('MainContent');
    var images = main.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      var box = images[i].getBoundingClientRect();
      var form = button && button.closest('form');
      if (box.width >= 240 && box.height >= 200 && !(form && form.contains(images[i]))) {
        var parent = images[i].parentElement;
        return parent;
      }
    }
    return null;
  }

  /* Low stock line on product pages. Follows the selected variant. */
  function startStock(button) {
    var box = document.querySelector('[data-irbn-stock]');
    if (!box) return;
    var counts = JSON.parse(box.getAttribute('data-irbn-stock'));
    var limit = Number(box.getAttribute('data-limit')) || 50;
    var form = button && button.closest && button.closest('form');
    var input = (form && form.querySelector('input[name="id"]')) || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    function paint() {
      var id = (input && input.value) || new URLSearchParams(window.location.search).get('variant') || box.getAttribute('data-variant');
      var qty = counts[id];
      box.hidden = qty === undefined;
      if (qty === undefined) return;
      box.querySelector('[data-irbn-stock-qty]').textContent = qty;
      box.querySelector('[data-irbn-stock-fill]').style.width = Math.max(6, Math.round(qty / limit * 100)) + '%';
    }
    paint();
    ['change', 'click'].forEach(function (name) {
      document.addEventListener(name, function () { setTimeout(paint, 80); }, true);
    });
  }

  function mountPdp() {
    var offer = document.getElementById('ir-bn-pdp-offer');
    if (!offer) return;
    var button = findAddButton();
    if (!button) return;
    var anchor = button;
    // Sit above the add-to-cart row, not inside a flex row with the button.
    while (anchor.parentElement && getComputedStyle(anchor.parentElement).display.indexOf('flex') > -1
      && getComputedStyle(anchor.parentElement).flexDirection.indexOf('row') > -1) anchor = anchor.parentElement;
    anchor.parentElement.insertBefore(offer.content.cloneNode(true), anchor);
    startStock(button);
    startPdpStamp(button);
    startCountdowns();
  }

  /* Sale stamp on the main product image. Galleries can rebuild after page load and pages can
     hold more than one, so this re-checks whenever the page changes. It shows on the first image only. */
  function startPdpStamp(button) {
    var stamp = document.getElementById('ir-bn-pdp-stamp');
    var main = document.getElementById('MainContent');
    if (!stamp || !main) return;
    function addTo(host) {
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var holder = document.createElement('span');
      holder.setAttribute('data-irbn-stamp-holder', '');
      holder.appendChild(stamp.content.cloneNode(true));
      host.appendChild(holder);
      return holder;
    }
    function holderIn(host) {
      return Array.prototype.slice.call(host.children).filter(function (child) { return child.hasAttribute('data-irbn-stamp-holder'); })[0];
    }
    function paint() {
      var stages = main.querySelectorAll('[data-ir-gallery-stage]');
      if (!stages.length) {
        if (main.querySelector('[data-irbn-stamp-holder]')) return;
        var gallery = findGallery(button);
        if (gallery) addTo(gallery);
        return;
      }
      Array.prototype.forEach.call(stages, function (stage) {
        var holder = holderIn(stage) || addTo(stage);
        var root = stage.closest('[data-ir-wrap-gallery-v5]') || stage.parentElement;
        var first = root.querySelector('.ir-wrap-gallery-v5__thumb');
        var showing = !first || first.getAttribute('aria-current') === 'true';
        var next = showing ? '' : 'none';
        if (holder.style.display !== next) holder.style.display = next;
      });
    }
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; paint(); });
    }).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current'] });
    paint();
    window.addEventListener('load', paint);
  }

  /* Free gift lines. */
  var GIFT_PROP = '_infraredi_gift';
  function isBnGift(item) { return /^black-november-/.test((item.properties && item.properties[GIFT_PROP]) || ''); }
  function spend(cart, excludeProductId) {
    return (cart.items || []).reduce(function (sum, item) {
      return isBnGift(item) || item.product_id === excludeProductId ? sum : sum + (item.final_line_price || 0);
    }, 0);
  }

  function startGifts() {
    var node = document.getElementById('ir-bn-gift-config');
    if (!node) return;
    var config = JSON.parse(node.textContent);
    if (!config.tiers || !config.tiers.length) return;
    var nativeFetch = window.fetch.bind(window);
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var read = function () { return nativeFetch(route + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
    var update = function (updates) { return nativeFetch(route + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ updates: updates }) }).then(function (r) { return r.json(); }); };
    var add = function (items) { return nativeFetch(route + 'cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: items }) }); };

    var rejected = {};

    // A two-gift tier starts on its first option until the customer picks the other.
    function chosen(tier) {
      var saved;
      try { saved = Number(sessionStorage.getItem('irBnGift' + tier.index)); } catch (_e) { saved = 0; }
      return tier.options.indexOf(saved) > -1 ? saved : tier.options[0];
    }

    async function swap(index, variantId) {
      var marker = 'black-november-' + index;
      delete rejected[index];
      try { sessionStorage.setItem('irBnGift' + index, String(variantId)); } catch (_e) { /* The cart line still records the pick. */ }
      var cart = await read();
      var lines = cart.items.filter(function (item) { return item.properties && item.properties[GIFT_PROP] === marker; });
      if (lines.length === 1 && lines[0].variant_id === variantId) return;
      if (lines.length) {
        var updates = {};
        lines.forEach(function (line) { updates[line.key] = 0; });
        await update(updates);
      }
      var props = {}; props[GIFT_PROP] = marker;
      await add([{ id: variantId, quantity: 1, properties: props }]);
    }

    async function reconcile(allowAdd) {
      var cart = await read();
      var total = spend(cart, config.excludeProductId);
      var changed = false;
      var updates = {};
      var missing = [];
      // One gift per order: only the highest tier reached counts.
      var top = config.tiers.filter(function (tier) { return total >= tier.threshold; }).pop();
      config.tiers.forEach(function (tier) {
        var marker = 'black-november-' + tier.index;
        var lines = cart.items.filter(function (item) { return item.properties && item.properties[GIFT_PROP] === marker; });
        var earned = !!top && tier.index === top.index;
        lines.forEach(function (line, i) { if (!earned || i > 0 || line.quantity !== 1) updates[line.key] = earned && i === 0 ? 1 : 0; });
        if (earned && !lines.length && allowAdd && tier.options.length && !rejected[tier.index]) {
          var props = {}; props[GIFT_PROP] = marker;
          missing.push({ id: chosen(tier), quantity: 1, properties: props });
        }
      });
      if (Object.keys(updates).length) { cart = await update(updates); changed = true; }
      if (missing.length) { await add(missing); cart = await read(); changed = true; }
      // A gift that Shopify has not priced at $0 never stays in the cart.
      var paid = (cart.items || []).filter(function (item) { return isBnGift(item) && item.final_line_price !== 0; });
      if (paid.length) {
        var remove = {};
        paid.forEach(function (item) {
          remove[item.key] = 0;
          rejected[item.properties[GIFT_PROP].replace('black-november-', '')] = true;
        });
        cart = await update(remove);
        changed = true;
      }
      return changed;
    }

    var queue = Promise.resolve();
    function refresh() { document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true })); }
    function enqueue(allowAdd) {
      queue = queue.then(function () { return reconcile(allowAdd); }).then(function (changed) { if (changed) refresh(); }).catch(function () {});
      return queue;
    }
    window.fetch = function (input, options) {
      var url;
      try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href); }
      catch (_e) { return nativeFetch(input, options); }
      var method = String((options && options.method) || (input && input.method) || 'GET').toUpperCase();
      var action = url.origin === window.location.origin && method === 'POST' && (url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/) || [])[1];
      var result = nativeFetch(input, options);
      if (action && action !== 'clear') result.then(function () { enqueue(true); }).catch(function () {});
      return result;
    };
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-irbn-pick]');
      if (!button) return;
      event.preventDefault();
      button.disabled = true;
      var index = button.getAttribute('data-irbn-pick');
      // The cart takes a few seconds to answer, so the tick moves on the click.
      document.querySelectorAll('[data-irbn-pick="' + index + '"]').forEach(function (option) {
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });
      var variantId = Number(button.getAttribute('data-variant'));
      queue = queue.then(function () { return swap(index, variantId); })
        .then(function () { return reconcile(false); })
        .then(refresh, refresh)
        .then(function () {
          // The drawer may not re-render, so the button can't be left switched off.
          button.disabled = false;
          if (!rejected[index]) return;
          // Wait for the drawer to refresh, or the message would be wiped with it.
          setTimeout(function () {
            var band = document.querySelector('.irbn-band');
            if (!band || band.querySelector('.irbn-band__notice')) return;
            var notice = document.createElement('p');
            notice.className = 'irbn-band__notice';
            notice.setAttribute('role', 'alert');
            notice.textContent = "We couldn't add this gift. Please try again or contact us before checking out.";
            band.appendChild(notice);
          }, 900);
        })
        .catch(function () {});
    });
    enqueue(false);
  }

  function startNavGlass() {
    var header = document.getElementById('IrHeaderV2');
    if (!header) return;
    var update = function () { header.classList.toggle('irbn-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', update, { passive: true });
    update();
    var bar = document.querySelector('.irbn-bar');
    if (bar && window.ResizeObserver) {
      new ResizeObserver(function () {
        document.documentElement.style.setProperty('--irbn-bar-h', bar.offsetHeight + 'px');
      }).observe(bar);
    }
  }

  /* Preview only: shows 25% off retail before real prices drop. Never runs on the published theme. */
  function startPreview() {
    var node = document.getElementById('ir-bn-preview-map');
    if (!node || !window.Shopify || !window.Shopify.theme || window.Shopify.theme.role === 'main') return;
    document.documentElement.classList.add('irbn-preview-on');
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    var rows = JSON.parse(node.textContent);
    var prices = {};
    var saves = {};
    rows.forEach(function (r) {
      prices[r[0]] = r[1];
      prices[r[2]] = r[3];
      saves[r[4]] = r[5];
    });
    var pattern = function (map) {
      var keys = Object.keys(map).sort(function (a, b) { return b.length - a.length; });
      if (!keys.length) return null;
      return new RegExp('(?:' + keys.map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')(?![\\d,.]*\\d)', 'g');
    };
    var priceRe = pattern(prices);
    var saveRe = pattern(saves);
    if (!priceRe) return;
    var skip = 'script,style,template,s,del,#CartDrawer,.irbn-band,.irbn-gifts,.irbn-tiers,.irbn-bar,.irbn-hero__body,.irbn-ticker,.irbn-bundle,.irpc-compare,.irbs2-compare,[data-ir-v5-bind],[id^="ir-bundle-"]';
    var written = new WeakMap();
    function struck(el) {
      for (var i = 0; el && i < 4; i++, el = el.parentElement) {
        if (getComputedStyle(el).textDecorationLine.indexOf('line-through') > -1) return true;
      }
      return false;
    }
    function apply() {
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      var hits = [];
      var text;
      while ((text = walker.nextNode())) {
        if (written.get(text) === text.nodeValue || text.nodeValue.search(/\d/) === -1) continue;
        priceRe.lastIndex = 0;
        if (saveRe) saveRe.lastIndex = 0;
        if (priceRe.test(text.nodeValue) || (saveRe && saveRe.test(text.nodeValue))) hits.push(text);
      }
      hits.forEach(function (t) {
        var parent = t.parentElement;
        if (!parent || parent.closest(skip) || struck(parent)) return;
        var isSave = !!parent.closest('[data-ir-variant-savings-amount],[data-ir-compare-difference]') || (/save/i.test(parent.textContent || '') && (parent.textContent || '').length < 40);
        var next = isSave && saveRe
          ? t.nodeValue.replace(saveRe, function (m) { return saves[m]; })
          : t.nodeValue.replace(priceRe, function (m) { return prices[m]; });
        written.set(t, next);
        if (next !== t.nodeValue) t.nodeValue = next;
      });
    }
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        observer.disconnect();
        apply();
        observer.observe(document.body, { subtree: true, childList: true, characterData: true });
      }, 120);
    });
    apply();
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  function init() {
    startPreview();
    startHeroTimer();
    startNavGlass();
    startGifts();
    startCardAdds();
    startCountdowns();
    mountPdp();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
